import * as types from "./mutation-type"
import gqlClient from '@/modules/graphql'
import { Promise } from "bluebird";
import { getPredictedTransactionsWeek, getPredictedTransactionsHourly } from './queries.graphql'

const actions = {
  async getHotFloorData({ commit }, { selectedDate, storeId, weekDates } = {}) {
    try {
      commit(types.GET_HOT_FLOOR_DATA_BEGIN);
      const { data: { data: { store: { statistics: { predictedTransactionsWeek } } } } } = await gqlClient.query({
        query     : getPredictedTransactionsWeek,
        variables : { date : selectedDate, storeId }
      })

      const hourlyStatsWeek = await Promise.map(weekDates, date => {
        return gqlClient.query({
          query     : getPredictedTransactionsHourly,
          variables : { date , storeId }
        }, {
          timeout : 150000
        })
          .then(({ data : { data : { store : { statistics : { predictedHourlyTransactionsOnDay } } } } }) => ({
            [date] : predictedHourlyTransactionsOnDay
          }))
      })
      
      let result = {}
      hourlyStatsWeek.forEach(stats => {
        result = { ...result, ...stats }
      })

      
      commit(types.GET_HOT_FLOOR_DATA_SUCCESS, {
        hourlyStatsWeek : result,
        predictedTransactionsWeek
      })
    } catch (e) {
      commit(types.GET_HOT_FLOOR_DATA_ERROR, e);
    }
  }
};
export default actions;
